exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-195fd3bc]:export{menu-bgc-oragne:#F2C46D}.lang-select[data-v-195fd3bc]{font-size:16px !important;display:inline-block}.lang-select span[data-v-195fd3bc]{cursor:pointer}.lang-select span[data-v-195fd3bc]:hover{color:#85BAE5}\n", ""]);

// exports
